import angular from 'angular';

import AlreadySubscribedNotificationComponent from './already-subscribed-notification.cmpt';

export default angular
    .module('application.component.notifications.component.already-subscribed-notification', [])
    .component(AlreadySubscribedNotificationComponent.selector, AlreadySubscribedNotificationComponent);



// WEBPACK FOOTER //
// ./src/application/component/notifications/component/already-subscribed-notification/index.js